import { drawArrow } from "./arrows";

export const door = (p5, trait, width, yurtTrait) => {
  const xcenter = width / 2;
  const ycenter = yurtTrait.h / 2 + 5 * trait.pixels;
  const boardW = trait.twoByW;
  const bottomBoard = {
    x: xcenter,
    y: ycenter + (yurtTrait.h / 2 + trait.twoByW / 2),
  };

  p5.push();
  p5.rectMode(p5.CENTER);
  p5.fill("lightgrey");
  p5.rect(
    bottomBoard.x + trait.doorW / 2 + boardW / 2,
    bottomBoard.y - trait.doorH / 2 - boardW / 2,
    boardW,
    trait.doorH
  );
  p5.rect(
    bottomBoard.x - trait.doorW / 2 - boardW / 2,
    bottomBoard.y - trait.doorH / 2 - boardW / 2,
    boardW,
    trait.doorH
  );
  p5.rect(
    bottomBoard.x,
    bottomBoard.y - trait.doorH - boardW,
    trait.doorW + boardW * 2,
    boardW
  );

  if (trait.windows) {
    p5.rect(
      bottomBoard.x + trait.doorW / 2 + boardW * 1.5,
      bottomBoard.y - trait.doorH / 2 - trait.twoByW,
      boardW,
      trait.doorH + trait.twoByW
    );
    p5.rect(
      bottomBoard.x - trait.doorW / 2 - boardW * 1.5,
      bottomBoard.y - trait.doorH / 2 - trait.twoByW,
      boardW,
      trait.doorH + trait.twoByW
    );
  } else {
    p5.rect(
      bottomBoard.x + trait.doorW / 2 + boardW * 1.5,
      bottomBoard.y - yurtTrait.h / 2 - boardW / 4,
      boardW,
      yurtTrait.h - boardW / 2
    );
    p5.rect(
      bottomBoard.x - trait.doorW / 2 - boardW * 1.5,
      bottomBoard.y - yurtTrait.h / 2 - boardW / 4,
      boardW,
      yurtTrait.h - boardW / 2
    );
  }

  p5.translate(
    xcenter,
    bottomBoard.y - trait.header / 2 - trait.doorH - boardW * 1.5
  );
  if (trait.windows) {
    p5.rect(0, 0, trait.w - trait.twoByW * 2, trait.header);
  } else {
    if (trait.headerAmount / trait.pixels !== 3) {
      p5.rect(0, 0, trait.doorW + boardW * 2, trait.header);
    }
  }
  p5.textAlign(p5.CENTER, p5.CENTER);
  p5.textSize(80 / trait.pixels);
  p5.fill("black");
  p5.stroke("white");
  p5.strokeWeight(3);
  if (trait.headerAmount / trait.pixels !== 3) {
    p5.text(
      `2 x ${Math.ceil(trait.header / trait.pixels)}`,
      0,
      40 / trait.pixels
    );
  }
  const headerTypes = ["SINGLE", "DOUBLE", "TRIPLE", "NONE"];

  if (trait.headerAmount / trait.pixels !== 3) {
    p5.text(
      `${headerTypes[trait.headerAmount / trait.pixels]} HEADER`,
      0,
      -40 / trait.pixels
    );
  }

  p5.pop();

  let doorH0 = p5.createVector(
    bottomBoard.x - trait.doorW / 4,
    bottomBoard.y - boardW / 2
  );
  let doorH1 = p5.createVector(0, -trait.doorH);

  drawArrow(p5, doorH0, doorH1, trait.doorH, trait.pixels);

  let doorW0 = p5.createVector(
    bottomBoard.x - trait.doorW / 2,
    bottomBoard.y - trait.doorH / 4
  );
  let doorW1 = p5.createVector(trait.doorW, 0);

  drawArrow(p5, doorW0, doorW1, trait.doorW, trait.pixels);

  let doorCrip = p5.createVector(
    bottomBoard.x - trait.doorW / 2.75,
    yurtTrait.h - trait.doorH + boardW * 2
  );

  let doorCrip1 = p5.createVector(0, -(yurtTrait.h - trait.doorH - boardW * 2));

  if (!trait.windows) {
    drawArrow(
      p5,
      doorCrip,
      doorCrip1,
      yurtTrait.h - trait.doorH - boardW * 4,
      trait.pixels
    );
  }
};
